import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import {
  LetpensiondkJobopslagListComponent
} from '@features/letpensiondk/letpensiondk-jobopslag/letpensiondk-jobopslag-list/letpensiondk-jobopslag-list.component';
import {
  LetpensiondkJobopslagDetailComponent
} from '@features/letpensiondk/letpensiondk-jobopslag/letpensiondk-jobopslag-detail/letpensiondk-jobopslag-detail.component';
import { JobopslagService } from '@features/letpensiondk/letpensiondk-jobopslag/jobopslag.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-letpensiondk-jobopslag',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    LetpensiondkJobopslagListComponent,
    LetpensiondkJobopslagDetailComponent,
    Button
  ],
  templateUrl: './letpensiondk-jobopslag.component.html',
  styleUrl: './letpensiondk-jobopslag.component.css'
})
export class LetpensiondkJobopslagComponent {
  jobopslagService = inject(JobopslagService);
}
